/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Service_UnavailableInputs */

const fr_error_service_unavailable = /** @type {(inputs: Error_Service_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le service est indisponible. Réessayez dans un instant.`)
};

const en_error_service_unavailable = /** @type {(inputs: Error_Service_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The service is unavailable. Try again in a moment.`)
};

/**
* | output |
* | --- |
* | "The service is unavailable. Try again in a moment." |
*
* @param {Error_Service_UnavailableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_service_unavailable = /** @type {((inputs?: Error_Service_UnavailableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Service_UnavailableInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_service_unavailable(inputs)
	return fr_error_service_unavailable(inputs)
});